<template>
  <div v-if="pendingList || !pendingList && !error">
    <main class="l-content">
      <section class="l-section wpb_row height_small mpc-row">
        <div class="l-section-h i-cf">
          <div class="g-cols type_default valign_top">
            <div class="vc_col-sm-12 wpb_column vc_column_container mpc-column"
                 data-column-id="mpc_column-155e8070cd1331e">
              <div class="vc_column-inner">
                <div class="wpb_wrapper">
                  <div class="w-blog layout_classic type_grid cols_2 with_filters">
                    <div class="g-filters style_2">
                      <div class="g-filters-list" :class="{_loading: pendingCategories}">
                        <BasePreloader v-if="pendingCategories"/>
                        <router-link
                          v-for="(item, index) in categories"
                          :key="index"
                          :to="{name: 'news-list', params: {categoryId: item.id, savedPosition: true}}"
                          class="g-filters-item">
                          <span>{{ item.name }}</span>
                        </router-link>
                      </div>
                    </div>
                    <div class="w-blog-list" :class="{_loading: pendingList}">
                      <BasePreloader v-if="pendingList"/>
                      <NewsCard v-for="item in items"
                                :key="item.id"
                                :card="item"
                      />
                      <div v-if="!pendingList && !items.length" class="empty">{{
                          $t('Нічого не знайдено')
                        }}
                      </div>
                    </div>

                    <div v-if="page && page < totalPages"
                         class="g-loadmore"
                         @click.prevent="onLoadMoreItems"
                    >
                      <div class="g-loadmore-btn">
                        <BasePreloader v-if="pendingList"/>
                        <span>{{ $t('Показати більше') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
  <ErrorView v-else/>

</template>

<script>
  import NewsCard from '@/components/NewsCard'
  import {http} from '@/axios'
  import ErrorView from '@/components/ErrorView'

  export default {
    name: 'NewsList',
    components: {ErrorView, NewsCard},
    data() {
      return {
        items: [],
        categories: [],
        pendingCategories: true,
        pendingList: true,
        page: 0,
        totalPages: 0,
        error: null
      }
    },
    computed: {
      categoryId() {
        return this.$route.params.categoryId || null
      }
    },
    methods: {
      loadCategories() {
        this.pendingCategories = true
        return http.get(`api/event/categories`)
          .then(({data}) => {
            this.categories = data.data.categories
            if (!this.$route.params.categoryId) {
              this.$router.replace({
                name: 'news-list',
                params: {categoryId: this.categories[0].id},
              })
            }
          })
          .finally(() => {
            this.pendingCategories = false
          })
      },
      load(shouldAdd) {
        this.pendingList = true
        let page = (this.page || 0) + 1

        this.error = null

        http.get(`api/event/events`, {
          params: {
            category_id: this.categoryId === 8 ? null : this.categoryId,
            page: page,
            page_size: 8
          }
        })
          .then(({data}) => {
            if (shouldAdd) {
              this.items = this.items.concat(data.data)
            } else {
              this.items = data.data
            }

            this.page = data.meta.current_page
            this.totalPages = data.meta.total_pages
          })
          .catch((error) => {
            this.items = []
            this.page = 0
            this.totalPages = 0
            this.error = error
          })
          .finally(() => {
            this.pendingList = false
          })
      },
      onLoadMoreItems() {
        this.load(true)
      }
    },
    async created() {
      await this.loadCategories()
      this.load()
    },
    watch: {
      '$route.params.categoryId'(to, from) {
        if (to !== from) {
          this.page = 0
          this.load()
        }
      }
    }
  }
</script>

<style lang="less">
  .g-filters-item._active {
    background-color: #f6f6f6;
    pointer-events: none;
  }

  .g-filters-list {
    position: relative;

    &._loading {
      min-height: 52px;
    }
  }

  .w-blog-list {
    position: relative;

    &._loading {
      min-height: 300px;
    }

    .preloader {
      width: 100% !important;
    }
  }
  .empty {
    width: 100% !important;
    text-align: center;
    padding: 0 15px 50px;
    font-size: 16px;
  }
</style>
